import React from 'react';
import Card from '../../ui/Card';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, ResponsiveContainer } from 'recharts';
const CompetitorRadarChart: React.FC = () => {
  const data = [{
    metric: 'Price',
    us: 75,
    competitor1: 82,
    competitor2: 68
  }, {
    metric: 'Technology',
    us: 88,
    competitor1: 75,
    competitor2: 92
  }, {
    metric: 'Reliability',
    us: 92,
    competitor1: 88,
    competitor2: 85
  }, {
    metric: 'Brand',
    us: 78,
    competitor1: 90,
    competitor2: 72
  }, {
    metric: 'Innovation',
    us: 85,
    competitor1: 70,
    competitor2: 88
  }];
  return <Card className="p-6" data-id="element-7011">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-7012">
        Competitor Benchmark Analysis
      </h3>
      <ResponsiveContainer width="100%" height={300} data-id="element-7013">
        <RadarChart data={data} data-id="element-7014">
          <PolarGrid stroke="#e5e7eb" data-id="element-7015" />
          <PolarAngleAxis dataKey="metric" tick={{
          fontSize: 12
        }} data-id="element-7016" />
          <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{
          fontSize: 10
        }} data-id="element-7017" />
          <Radar name="Our Company" dataKey="us" stroke="#3b82f6" fill="#3b82f6" fillOpacity={0.3} data-id="element-7018" />
          <Radar name="Competitor A" dataKey="competitor1" stroke="#ef4444" fill="#ef4444" fillOpacity={0.3} data-id="element-7019" />
          <Radar name="Competitor B" dataKey="competitor2" stroke="#10b981" fill="#10b981" fillOpacity={0.3} data-id="element-7020" />
          <Legend data-id="element-7021" />
        </RadarChart>
      </ResponsiveContainer>
    </Card>;
};
export default CompetitorRadarChart;